// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"80089e54","79":"f8a37cb9","230":"5fc93053","318":"14153678","671":"d65fee7a","763":"7292af08","782":"3fc07888","787":"3a25dc6f","801":"38a0015b"}[chunkId] + ".chunk.js";
};